
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component<EditResponseField>({
    model: {
        prop: 'value',
        event: 'input',
    },
})
export default class EditResponseField extends Vue {
    @Prop(String) public value!: string
    @Prop(String) public label!: string
    @Prop(String) public placeholder!: string

    public get prettyLabel() {
        return this.label.replace(/_c$/, '')
    }
}
